import React, { useEffect, useState } from "react";
import "./App.css";
import "./list-pages.css";
import { api } from "./lib/api";
import Login from "./components/Login";
import Dashboard from "./components/Dashboard";
import AuthCallback from "./components/AuthCallback";
import LandingPortal from "./components/LandingPortal";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS,
// THIS BREAKS THE AUTH.
const isOnAuthCallback = () =>
  window.location.pathname === "/auth-callback" ||
  (window.location.hash || "").includes("session_id=");

export default function App() {
  const [profile, setProfile] = useState(null);
  const [checking, setChecking] = useState(true);
  // Signed-out visitors land on the public portal first; clicking the
  // gated "Bookkeeping" card flips this flag and reveals <Login>.
  const [enteringBookkeeping, setEnteringBookkeeping] = useState(false);
  const handlingCallback = isOnAuthCallback();

  useEffect(() => {
    // If we're processing the Google callback, let AuthCallback own the flow.
    if (handlingCallback) { setChecking(false); return; }
    // If the URL already targets /login (e.g. external links, or someone
    // bookmarked it), skip the portal and go straight to <Login>.
    if (window.location.pathname === "/login") setEnteringBookkeeping(true);
    // Auth is now stored in an HttpOnly cookie — ask the backend whether
    // we still have a valid session by hitting /me. 401 means signed out.
    api.me()
      .then(setProfile)
      .catch(() => { /* not signed in — show the portal */ })
      .finally(() => setChecking(false));
  }, [handlingCallback]);

  const refreshProfile = async () => {
    try { setProfile(await api.me()); }
    catch { setProfile(null); }
  };

  const handleLogout = () => {
    setProfile(null);
    setEnteringBookkeeping(false); // back to portal on logout
  };

  if (checking) {
    return (
      <div className="login-wrap">
        <div className="loading-row"><span className="spinner" /> Loading…</div>
      </div>
    );
  }

  if (handlingCallback) {
    return <AuthCallback onSuccess={refreshProfile} />;
  }

  if (profile) {
    return <Dashboard profile={profile} onLogout={handleLogout} />;
  }

  if (enteringBookkeeping) {
    return (
      <Login
        onLogin={refreshProfile}
        onBack={() => setEnteringBookkeeping(false)}
      />
    );
  }

  return (
    <LandingPortal onEnterBookkeeping={() => setEnteringBookkeeping(true)} />
  );
}
